import { API } from "../APIs";
import { Pagination, Tokens } from "../Interfaces/Interfaces";
import { TokenValidator } from "./TokenValidator";

export default class TransactionService {
  tokens: any | Tokens;
  get = API.transactions + "get/";
  post = API.transactions + "post/";
  put = API.transactions + "put/";
  getFundTransfer = API.fundsTransfer + "get/";
  getBillTransfer = API.bills + "get/";
  newDashboard = API.newDashboard;
  TransactionDashboard = API.transactionDashboard +"get/";
  constructor() {
    this.tokens = TokenValidator();
  }

  async getTransactionSummary(id: string) {
    try {
      let response = await fetch(
        this.get + `transaction/GetAggregatorTransactionSummary/${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  async getTransactionSummaryCount(id: string) {
    try {
      let response = await fetch(
        this.get + `transaction/getaggregatorpersonaltransactionscount/${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  async transactionTypes() {
    try {
      let response = await fetch(this.get + `transaction/transactiontypes`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getTransactionDetails(id: string) {
    try {
      let response = await fetch(this.get + `transaction/getDetails/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getTransactions(data: Pagination) {
    try {
      let response = await fetch(
        this.get +
          `transaction/getAggregatorTransactions/${data.id}/${data.page}/${data.pageSize}/${data.whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getAggregatorPersonalTransactions(data: Pagination) {
    try {
      let response = await fetch(
        this.get +
          `transaction/getAggregatorPersonalTransactions/${data.id}/${data.page}/${data.pageSize}/${data.whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  //getAggregatorPersonalTransactions

  async getTransactionsByUser(data: Pagination) {
    try {
      let response = await fetch(
        this.get +
          `transaction/getTransactions/${data.page}/${data.pageSize}/${data.whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getCoordinatorTransactions(data: Pagination) {
    try {
      let response = await fetch(
        this.get +
          `transaction/getCoordinatorTransactions/${data.page}/${data.pageSize}/${data.whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getAggregatorTransactions(data: Pagination) {
    try {
      let response = await fetch(
        this.get +
          `transaction/getAggregatorTransactions/${data.page}/${data.pageSize}/${data.whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getAgentTransactions(data: Pagination) {
    try {
      let response = await fetch(
        this.get +
          `transaction/getAgentTransactions/${data.id}/${data.page}/${data.pageSize}/${data.whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getCustomerDashboard(id: string) {
    try {
      let response = await fetch(
        this.get + `transaction/getAgentSavingsDashboard/${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getAgentDashboard(id: string) {
    try {
      let response = await fetch(
        this.get + `transaction/getAgentDashboard/${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  async getCordinatorDashboard() {
    try {
      let response = await fetch(
        this.get + `transaction/getCordinatorDashboard/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async reconfirmTransactions(data: any) {
    switch (data.transactionType) {
      case "Transfer":
        try {
          let response = await fetch(
            this.getFundTransfer +
              `TransferLog/getdetailbyreference/${data.ref}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${this.tokens.access_token}`,
                "x-api-key": `${process.env.REACT_APP_API_KEY}`,
              },
            }
          );

          return await response.json();
        } catch (err) {
          throw err;
        }

      case "Bill Payment":
        try {
          let response = await fetch(
            this.getBillTransfer + `billtransaction/GetByReference/${data.ref}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${this.tokens.access_token}`,
                "x-api-key": `${process.env.REACT_APP_API_KEY}`,
              },
            }
          );

          return await response.json();
        } catch (err) {
          throw err;
        }
      default:
        return;
    }
  }
  async getReconfirmTransactionMessagePage(data: any) {
    try {
      let response = await fetch(
        this.get + `transaction/Confirmation/${data.ref}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async sendreconfirmTransactions(data: any) {
    switch (data.transactionType) {
      case "Transfer":
        try {
          let response = await fetch(
            this.get + `transaction/Confirmation/${data.ref}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${this.tokens.access_token}`,
                "x-api-key": `${process.env.REACT_APP_API_KEY}`,
              },
            }
          );

          return await response.json();
        } catch (err) {
          throw err;
        }
      case "Bill Payment":
        try {
          let response = await fetch(
            this.getBillTransfer + `billtransaction/GetByReference/${data.ref}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${this.tokens.access_token}`,
                "x-api-key": `${process.env.REACT_APP_API_KEY}`,
              },
            }
          );

          return await response.json();
        } catch (err) {
          throw err;
        }
      default:
        return;
    }
  }

  async performanceTarget() {
    try {
      let response = await fetch(
        this.TransactionDashboard + `Dashboard/gettargetperagent`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  async agentPerformanceTarget(agentId: string) {
    try {
      let response = await fetch(
        this.get + `transactionTarget/getByAgent/${agentId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async aggregatorPerformanceTarget(data: any) {
    try {
      let response = await fetch(
        this.get +
          `transactionTarget/getbyaggregator/${data.id}/${data.whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
}
